export default {
  methods: {
    filterTable (elems, event) {
      const searchText = event.searchText
      const selectedColumn = event.selectedColumn
      if (!searchText || searchText === '') return elems
      return elems.filter(function (elem) {
        return elem[selectedColumn] !== undefined && elem[selectedColumn] !== null ? elem[selectedColumn].toString().toLowerCase().includes(searchText.toLowerCase()) : false
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/FilterTable.js